import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import SuitabilityTestConfirm from "@/components/SuitabilityTests/SuitabilityTestConfirm";
import
{
    buildIdentitiesListNavigationState,
    IdentitiesPath,
    type SuitabilityTestRenewalNavigationState,
} from "@/screen/Identities/identitiesRoutes";

const SuitabilityRenewedMessage = "El test de idoneidad se ha renovado.";

/**
 * Confirmación de la renovación. Volver y cancelar salen al listado de intervinientes,
 * no al formulario: al firmar queda un test nuevo y el listado se recarga al montarse.
 */
const SuitabilityTestRenewalConfirmScreen: React.FC = () =>
{
    const history = useHistory();
    const location = useLocation<SuitabilityTestRenewalNavigationState>();
    const userIdentityId = location.state?.userIdentityId;

    useEffect(() =>
    {
        if(!userIdentityId)
        {
            history.replace(IdentitiesPath);
        }
    }, [userIdentityId, history]);

    if(!userIdentityId)
    {
        return null;
    }

    const leaveBecauseOfLimit = (message: string): void =>
    {
        history.replace(IdentitiesPath, buildIdentitiesListNavigationState(undefined, undefined, message));
    };

    return(
        <SuitabilityTestConfirm
            userIdentityId={userIdentityId}
            returnRoute={IdentitiesPath}
            cancelRoute={IdentitiesPath}
            returnNavigationState={buildIdentitiesListNavigationState(undefined, SuitabilityRenewedMessage)}
            onLimitReached={leaveBecauseOfLimit}
        />
    );
};

export default SuitabilityTestRenewalConfirmScreen;
